// extracted by css-extract-rspack-plugin
module.exports =  {"model-answer-container":"Template38-mMLj__model-answer-container","model-answer-title":"Template38-gJXf__model-answer-title","model-answer":"Template38-wiQA__model-answer"};